import React from 'react'
import MaxContent from '../../layout/MaxContent'
import { fixStrapiUrl } from "../../helpers/strapiUrl";

interface StrapiData {
  data: {
    SingleImage: {
      url: string
    }
    AlternativeText: string;
    ImageURL: string;
  }
}

const Image: React.FC<StrapiData> = ({ data }) => {
  if ( data.ImageURL) {
    return (
      <img
          src={data?.ImageURL}
          alt={data?.AlternativeText}
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
    )
  } else {
    return (
      <MaxContent size='content'>
        <img
          src={fixStrapiUrl(data.SingleImage?.url)}
          alt={data?.AlternativeText}
          className="w-full h-full object-cover object-center"
          loading="lazy" />
      </MaxContent>
    )
  }

}

export default Image